import { Outlet } from "react-router";
import Layout from "../components/Layout/Layout";
import { useAuthStore } from "../hooks/useAuth";

const Root = () => {
  const authenticated = useAuthStore.use.authenticated();

  if (authenticated) {
    return (
      <Layout>
        <Outlet />
      </Layout>
    );
  } else {
    return (
      <div>
        <Outlet />
      </div>
    );
  }
};
export default Root;
